var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"compulsory_license"}},[_c('custom-header',{attrs:{"title":_vm.certDownload.area01_Title,"subTitle":_vm.certDownload.area01_SubTitle,"image":_vm.certDownload.area01_Image,"buttonName":_vm.certDownload.area01_ButtonName,"buttonURL":_vm.certDownload.area01_ButtonURL}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }